// A small, stable topic vocabulary keeps filters useful across conversations.
// Derived from the saved title (initial question); no extra model request or storage.
const TOPICS = [
  ["Work orders", /\bwork\s*orders?\b|\bservice requests?\b|工单|报修/gi],
  ["Equipment", /\bequipment\b|\bassets?\b|\bhvac\b|\bboilers?\b|\bchillers?\b|\bpumps?\b|设备|空调|锅炉/gi],
  ["Maintenance", /\bmaintenance\b|\bpreventive\b|\bpm\b|\brepairs?\b|维护|维保|保养|维修/gi],
  ["Utilities", /\butilit(?:y|ies)\b|\benergy\b|\belectric(?:ity|al)?\b|\bwater\b|\bgas\b|\beui\b|\bkwh\b|能耗|能源|电费|水费|燃气/gi],
  ["Savings", /\bsavings?\b|\befficiency\b|\bconservation\b|\broi\b|节能|节省|节约/gi],
  ["Budgets", /\bbudgets?\b|\bcosts?\b|\bspend(?:ing)?\b|\bexpenses?\b|预算|成本|费用/gi],
  ["Inspections", /\binspections?\b|\bcompliance\b|\bcertif(?:ication|y)\b|\bsafety\b|\btesting\b|巡检|检查|合规|安全/gi],
  ["Reports", /\breports?\b|\bkpis?\b|\bdashboards?\b|\bbenchmarks?\b|报告|报表|指标|对标/gi],
];

export const conversationTags = (conversation) => {
  const title = String(conversation?.title || "").normalize("NFKC");
  const matches = TOPICS.map(([label, pattern], index) => ({
    label, index, score: (title.match(pattern) || []).length,
  })).filter((item) => item.score > 0);
  matches.sort((a, b) => b.score - a.score || a.index - b.index);
  return matches.length ? matches.slice(0, 2).map((item) => item.label) : ["General"];
};

export const topicCounts = (conversations) => {
  const counts = new Map();
  conversations.forEach((conversation) => conversationTags(conversation).forEach((tag) => {
    counts.set(tag, (counts.get(tag) || 0) + 1);
  }));
  return [...counts].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]));
};

export const filterConversations = (conversations, { search = "", topic = "", pinned = false } = {}) => {
  const query = search.trim().toLocaleLowerCase();
  return conversations.filter((conversation) => {
    const tags = conversationTags(conversation);
    return (!pinned || conversation.is_pinned) && (!topic || tags.includes(topic)) &&
      (!query || [conversation.title || "", ...tags].join(" ").toLocaleLowerCase().includes(query));
  });
};

// Fetch each scoped page without following arbitrary absolute next URLs.
// Deduplicate rows if activity reorders a conversation while pages are read.
export const collectConversationPages = async (readPage) => {
  const rows = new Map();
  for (let page = 1; ; page += 1) {
    const payload = await readPage(page);
    const items = Array.isArray(payload) ? payload : payload?.results;
    if (!Array.isArray(items)) throw new Error("Unable to read conversation history.");
    items.forEach((item) => rows.set(item.id, item));
    if (Array.isArray(payload) || !payload.next) break;
    if (!items.length || page >= 1000) throw new Error("Conversation history could not be fully loaded. Please retry.");
  }
  return [...rows.values()];
};
